import { useData } from '../../../utils/hooks/useData';
import { calculatePercentageDifference, formatFromAndToQuery } from '../../lib';

import AnalyticsError from '../../AnalyticsError';

export default function FormSubmissionCard({
  form,
  adminAnalyticsFormPath,
  totalSubmissionsPath,
  submissionsDuringPeriodPath,
  isComparing,
  dateRange,
  dateRangeTwo,
}) {
  const { data: totalSubmissions, isLoading: isLoadingTotalSubmissions, error: errorTotalSubmissions } = useData(`${totalSubmissionsPath(form.id)}.json`);

  const {
    data: selectedPeriodSubmissions,
    isLoading: isLoadingSelectedPeriodSubmissions,
    error: errorSelectedPeriodSubmissions,
  } = useData(`${submissionsDuringPeriodPath(form.id)}.json?${formatFromAndToQuery(dateRange)}`);

  const isComparable = isComparing && dateRange.from && dateRange.to;

  const {
    data: selectedPeriodSubmissionsTwo,
    isLoading: isLoadingSelectedPeriodSubmissionsTwo,
    error: errorSelectedPeriodSubmissionsTwo,
  } = useData(`${submissionsDuringPeriodPath(form.id)}.json?${formatFromAndToQuery(dateRangeTwo)}`, isComparable);

  return (
    <a href={adminAnalyticsFormPath(form.id)} key={form.id}>
      <div className="card text-white lift" style={{ maxWidth: 700 }}>
        <div className="card-body">
          <div className="g-0 mb-4 fs-3 d-flex justify-content-between align-items-center gap-2">
            <i className="fe fe-file-text" />
            {form.name}
            <span />
          </div>
          <div className="row g-0 border-bottom border-top">
            <div className="col py-4 text-center">
              <h6 className="text-uppercase text-muted">Total</h6>
              <div className="h2 mb-0">
                {isLoadingTotalSubmissions ? (
                  <div className="spinner-border spinner-border-sm" role="loading">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                ) : errorTotalSubmissions ? (
                  <div className="d-flex gap-2">
                    <span>Stat:</span>
                    <AnalyticsError errorMsg={errorTotalSubmissions} />
                  </div>
                ) : (
                  totalSubmissions
                )}
              </div>
            </div>
            <div className="col py-4 text-center border-start">
              <h6 className="text-uppercase text-muted">Selected Period</h6>
              <div className="h2 mb-0 d-flex align-items-center justify-content-center gap-2">
                {isLoadingSelectedPeriodSubmissions ? (
                  <div className="spinner-border spinner-border-sm" role="loading">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                ) : errorSelectedPeriodSubmissions ? (
                  <div className="d-flex gap-2">
                    <span>Stat:</span>
                    <AnalyticsError errorMsg={errorTotalSubmissions} />
                  </div>
                ) : (
                  selectedPeriodSubmissions
                )}
                {isComparable && (
                  <div className="text-muted fs-4">
                    {isLoadingSelectedPeriodSubmissionsTwo ? (
                      <div className="spinner-border spinner-border-sm" role="loading">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    ) : errorSelectedPeriodSubmissionsTwo ? (
                      <div className="d-flex gap-2">
                        <span>Stat:</span>
                        <AnalyticsError errorMsg={errorSelectedPeriodSubmissionsTwo} />
                      </div>
                    ) : (
                      `${selectedPeriodSubmissionsTwo} (${calculatePercentageDifference(selectedPeriodSubmissions, selectedPeriodSubmissionsTwo)})`
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </a>
  );
}
